// extracted by mini-css-extract-plugin
export default {"dcuiThemingLogoContainer":"dcui-theming-logo-container__dcui-theming-logo-container__ZLGGx","logoWithMaxWidth":"dcui-theming-logo-container__logo-with-max-width__RpLqU"};